import { render, staticRenderFns } from "./dataSummaryScreenYuanshi.vue?vue&type=template&id=71d24080&scoped=true&"
import script from "./dataSummaryScreenYuanshi.vue?vue&type=script&lang=js&"
export * from "./dataSummaryScreenYuanshi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71d24080",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71d24080')) {
      api.createRecord('71d24080', component.options)
    } else {
      api.reload('71d24080', component.options)
    }
    module.hot.accept("./dataSummaryScreenYuanshi.vue?vue&type=template&id=71d24080&scoped=true&", function () {
      api.rerender('71d24080', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/datalist/dataSummaryScreenYuanshi.vue"
export default component.exports